import React from "react";
import { Typography, Button, Space, Layout } from "antd";
import { ToolOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;
const { Content } = Layout;

const MaintenancePage = ({ setMaintenance }) => {
  return (
    <Layout style={{ height: "100vh", backgroundColor: "#f0f2f5" }}>
      <Content
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <ToolOutlined
          style={{ fontSize: "100px", color: "#fa8c16", marginBottom: "20px" }}
        />
        <Title level={2} style={{ color: "#595959" }}>
          {"We'll be back soon!"}
        </Title>
        <Text type="secondary" style={{ fontSize: "16px", maxWidth: "600px" }}>
          Our website is currently undergoing scheduled maintenance. Thank you
          for your patience. We’ll be back up and running shortly!
        </Text>
        <Space style={{ marginTop: "20px" }}>
          <Button
            className="save-btn"
            size="large"
            shape="round"
            onClick={() => setMaintenance(false)}
          >
            Go to LoginPage
          </Button>
        </Space>
      </Content>
    </Layout>
  );
};

export default MaintenancePage;
